module.exports = __webpack_public_path__ + "media/country_flags/ee-27a27cd9.png";